import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import ReferenceCardDeck from './ReferenceCardDeck';

const ReferenceContainer = ({ topicId }) => {
    const [references, setReferences] = useState([]);
    const [loading, setLoading] = useState(true);
    const [noDataMessage, setNoDataMessage] = useState('');

    useEffect(() => {
        const fetchReferences = async () => {
            setReferences([]);
            setLoading(true);
            try {
                const response = await fetch(`/api/reference/${topicId}`);
                const data = await response.json();
                setReferences(data.data);
                setNoDataMessage(data.data.length === 0 ? 'No learning materials found for this topic' : '');
            } catch (error) {
                console.error('Failed to fetch references:', error);
                setNoDataMessage('Failed to fetch data');
            }
            setLoading(false);
        };

        fetchReferences();
    }, [topicId]);

    return (
        <div id="reference-container">
            <div className="row margin-btm-15">
                <div className="col-12 align-center margin-top-30">
                    <span className="container-title">Learning Materials</span>
                </div>
            </div>
            {!loading && references.length === 0 && (
                <div className="no-data-prompt">
                    {noDataMessage || 'No result yet'}
                </div>
            )}
            {loading && (
                <div className="no-data-prompt">
                    <Skeleton count={1} width={200} />
                </div>
            )}
            <ReferenceCardDeck topicId={topicId} cards={references}/>
        </div>
    );
};

export default ReferenceContainer;
